import {
  Brain,
  Briefcase,
  HeartHandshake,
  HeartPulse,
  type LucideIcon,
  Palette,
  PiggyBank,
  Target,
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  health: HeartPulse,
  career: Briefcase,
  mind: Brain,
  finance: PiggyBank,
  relationships: HeartHandshake,
  creative: Palette,
}

export function categoryIcon(category: string | undefined): LucideIcon {
  return ICONS[category?.toLowerCase() ?? ''] ?? Target
}
